export default "__VITE_ASSET__CvYaABDe__"